import React, { useState } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import './Auth.css';
import { auth } from "../firebase";
import firebase from 'firebase/compat/app';

const Login = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";


  const handleEmailLogin = async e => {
    e.preventDefault();
    // Validação básica
    if (!email || !password) {
      setError('Por favor, preencha todos os campos.');
      return;
    }
    setError('');
    try {
      await auth.signInWithEmailAndPassword(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      console.log("----------------------Erro ao logar:-----------------");
      console.log(err.code);

      switch (err.code) {
        case 'auth/invalid-credential':
          setError(
            'Credenciais inválidas ou expiradas. ' +
            'Verifique se você está usando o método de login correto:\n' +
            '- Se você cadastrou com Google, clique em "Entrar com Google".\n' +
            '- Se cadastrou com Email e Senha, use seu email e senha.\n' +
            '- Caso não lembre a senha, use "Esqueci minha senha".'
          );
          break;
        case 'auth/user-not-found':
          setError('Nenhuma conta encontrada com esse email.');
          break;
        case 'auth/wrong-password':
          setError('Senha incorreta. Tente novamente.');
          break;
        case 'auth/invalid-email':
          setError('Email inválido. Verifique e tente de novo.');
          break;

        default:
          setError(err.message);
      }
    }
  };

  const handleGoogleLogin = async () => {
    setError('');
    const provider = new firebase.auth.GoogleAuthProvider();
    try {
      await auth.signInWithPopup(provider);
      navigate(from, { replace: true });
    } catch (err) {
      if (err.code === 'auth/account-exists-with-different-credential') {
        setError('Já existe conta com este email usando outro método. Use login anterior.');
      } else {
        setError(err.message);
      }
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="logo">
            <div className="logo-icon">
              <i className="fas fa-brain"></i>
            </div>
            <h1>Academia <span>Gama</span></h1>
          </div>
          <h2>Bem-vindo de volta!</h2>
          <p>Entre para continuar sua jornada de desenvolvimento</p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleEmailLogin}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu.email@exemplo.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Sua senha"
            />
          </div>

          <div className="form-options">
            <div className="remember-me">
              <input
                type="checkbox"
                id="remember"
                checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
              />
              <label htmlFor="remember">Lembrar de mim</label>
            </div>
            <Link to="/forgot-password">Esqueceu a senha?</Link>
          </div>

          <button type="submit" className="auth-button">Entrar</button>
        </form>

        <div className="auth-divider">
          <span>ou</span>
        </div>

        <button className="google-button" onClick={handleGoogleLogin}>
          <div className="google-icon">
            <i className="fab fa-google"></i>
          </div>
          Entrar com Google
        </button>

        <div className="auth-footer">
          Não tem uma conta? <Link to="/signup">Cadastre-se</Link>
        </div>
        <div className="auth-footer">
          Volte ao <Link to="/">Ínicio</Link> para continuar a explorar!
        </div>
      </div>

      <div className="auth-visual">
        <div className="visual-content">
          <h3>Sua jornada de desenvolvimento continua aqui</h3>
          <p>Acesse seu perfil completo, currículo dinâmico e continue seus módulos de desenvolvimento pessoal e profissional</p>
          <div className="features">
            <div className="feature">
              <i className="fas fa-graduation-cap"></i>
              <span>Continue seus módulos</span>
            </div>
            <div className="feature">
              <i className="fas fa-file-alt"></i>
              <span>Acesse seu currículo dinâmico</span>
            </div>
            <div className="feature">
              <i className="fas fa-chart-line"></i>
              <span>Acompanhe seu progresso</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;